import { mapActions, mapState } from 'vuex';
import { formMixin, validators } from '@/components/forms/mixin';
import { snakeCase } from 'lodash';
import { maxLength as vMaxLength } from 'vuelidate/lib/validators';
import externalLinksMixin from '@/mixins/externalLinks';
import ls from '@/helpers/localStorage';

const PROVIDER_FACEBOOK = 'Facebook';
const PROVIDER_TWITTER = 'Twitter';
const PROVIDER_GOOGLE = 'Google';
const CACHE_NAME = 'register-external';
const MAX_USERNAME_LENGTH = 14;
const MAX_EMAIL_LENGTH = 50;

export default {
  mixins: [
    formMixin,
    externalLinksMixin,
  ],
  validations: {
    fields: {
      email: {
        ...validators.email,
        maxLength: vMaxLength(MAX_EMAIL_LENGTH),
      },
      emailConfirmation: {
        ...validators.emailConfirmation('email'),
        maxLength: vMaxLength(MAX_EMAIL_LENGTH),
      },
      username: validators.username,
    },
  },
  data() {
    return {
      fields: {
        email: '',
        emailConfirmation: '',
        username: '',
      },
      error: null,
    };
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapState('popup', ['formDataCache']),
  },
  mounted() {
    if (this.userInfo && this.userInfo.userName) {
      this.fields.username = this.getNormalizedSuggestedUserName(this.userInfo.userName);
      this.$v.fields.username.$touch();
    }
    if (this.formDataCache !== null && CACHE_NAME === this.formDataCache.route) {
      this.fields = {
        ...this.fields,
        ...this.formDataCache,
      };
    }
    if (this.fields.email) {
      this.$v.fields.email.$touch();
    }
    if (this.fields.emailConfirmation) {
      this.$v.fields.emailConfirmation.$touch();
    }
  },
  watch: {
    userInfo() {
      this.fields.username = this.getNormalizedSuggestedUserName(this.userInfo.userName);
      this.$v.fields.username.$touch();
    },
  },
  methods: {
    ...mapActions('user', ['registerExternal']),
    ...mapActions('popup', ['setCurrentPopup', 'cacheFormData']),
    closePopupAndRedirect() {
      this.setCurrentPopup();
      this.getExternalLogins({})
        .then((response) => {
          this.links = response.data;
          const provider = this.userInfo.loginProvider;
          switch (provider) {
            case PROVIDER_FACEBOOK:
              this.facebookLinkClick();
              break;
            case PROVIDER_TWITTER:
              this.twitterLinkClick();
              break;
            case PROVIDER_GOOGLE:
              this.googleLinkClick();
              break;
            default:
              break;
          }
        });
    },
    onSubmit() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'submit',
        label: 'Create Account',
      });
      if (this.formIsValid() && this.formDisable()) {
        const payload = {
          email: this.fields.email,
          userName: this.fields.username,
        };
        this.registerExternal(payload)
          .then(this.formEnable)
          .then(() => {
            ls.set('registeredExternal', true);
            this.closePopupAndRedirect();
          })
          .catch(error => this.formHandleErrors(error));
      }
    },
    // Normalize only provider-suggested defaults (and cap at backend max length).
    // We intentionally do not re-normalize at submit time so the validated input value
    // the user sees is exactly what gets posted.
    getNormalizedSuggestedUserName(value) {
      if (!value) {
        return '';
      }
      return snakeCase(value).slice(0, MAX_USERNAME_LENGTH);
    },
  },
  beforeDestroy() {
    this.cacheFormData({ ...this.fields, route: CACHE_NAME });
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-register-external/account-register-external.js